import { createApi } from '@reduxjs/toolkit/query/react'

import { getBaseQueryWithMockError } from '@/shared/api/custom-fetch-base'
import { IUser, TUserCreate } from '@/shared/types/user'

const mock = [
  [
    {
      createdBy: null,
      createdAt: '2025-04-09T02:59:25.202Z',
      id: 24,
      username: 'admin@test.ru',
      email: 'admin@test.ru',
      status_email: 'none',
      phone: '+79991234568',
      status_phone: 'none',
      fio: 'Админ Рутович ++',
      organizations: [
        {
          organizationId: 10,
          roleId: 1,
          role: {
            id: 1,
            name: 'admin',
            label: 'Администратор',
          },
        },
      ],
      offices: [
        { officeId: 15, roleId: 1 },
        { officeId: 16, roleId: 1 },
        { officeId: 17, roleId: 1 },
      ],
    },
    {
      createdBy: null,
      createdAt: '2025-04-10T04:42:13.597Z',
      id: 25,
      username: 'ivanov@test.ru',
      email: 'ivanov@test.ru',
      status_email: 'none',
      phone: '+79991236666',
      status_phone: 'none',
      fio: 'Иванов Виан Иванович',
      organizations: [
        {
          organizationId: 10,
          roleId: 1,
          role: {
            id: 1,
            name: 'admin',
            label: 'Администратор',
          },
        },
      ],
      offices: [
        { officeId: 15, roleId: 1 },
        { officeId: 16, roleId: 1 },
        { officeId: 17, roleId: 1 },
      ],
    },
    {
      createdBy: null,
      createdAt: '2025-04-11T04:41:40.727Z',
      id: 28,
      username: 'user@test.ru',
      email: 'user@test.ru',
      status_email: 'none',
      phone: null,
      status_phone: 'none',
      fio: 'Юзер Бегинович',
      organizations: [
        {
          organizationId: 10,
          roleId: 2,
          role: {
            id: 2,
            name: 'user',
            label: 'Пользователь',
          },
        },
      ],
      offices: [
        { officeId: 15, roleId: 1 },
        { officeId: 16, roleId: 1 },
        { officeId: 17, roleId: 1 },
      ],
    },
    {
      createdBy: null,
      createdAt: '2025-04-16T13:23:10.734Z',
      id: 29,
      username: 'user1@test.ru',
      email: 'user1@test.ru',
      status_email: 'none',
      phone: null,
      status_phone: 'none',
      fio: 'Юзер Бегинович первый',
      organizations: [
        {
          organizationId: 10,
          roleId: 2,
          role: {
            id: 2,
            name: 'user',
            label: 'Пользователь',
          },
        },
      ],
      offices: [
        { officeId: 15, roleId: 1 },
        { officeId: 16, roleId: 1 },
        { officeId: 17, roleId: 1 },
      ],
    },
    {
      createdBy: null,
      createdAt: '2025-05-22T04:14:18.321Z',
      id: 30,
      username: 'petrov@test.ru',
      email: 'petrov@test.ru',
      status_email: 'none',
      phone: null,
      status_phone: 'none',
      fio: 'П.П. Петров',
      organizations: [
        {
          organizationId: 10,
          roleId: 1,
          role: {
            id: 1,
            name: 'admin',
            label: 'Администратор',
          },
        },
      ],
      offices: [
        { officeId: 15, roleId: 1 },
        { officeId: 16, roleId: 1 },
        { officeId: 17, roleId: 1 },
      ],
    },
  ],
  5,
]

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: getBaseQueryWithMockError(mock),
  tagTypes: ['users'],
  endpoints: build => ({
    userList: build.query<[IUser[], number], void>({
      query: () => ({
        url: 'users',
        method: 'GET',
      }),
      providesTags: ['users'],
    }),

    getUser: build.query<IUser, number>({
      query: id => ({
        url: `users/${id}`,
        method: 'GET',
      }),
      providesTags: ['users'],
    }),

    createUser: build.mutation<IUser, TUserCreate>({
      query: body => ({ url: `users`, method: 'POST', body }),
      invalidatesTags: ['users'],
    }),

    updateUser: build.mutation<IUser, { id: number; body: Partial<IUser> }>({
      query: ({ id, body }) => ({
        url: `users/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['users'],
    }),

    removeUser: build.mutation<unknown, number>({
      query: id => ({ url: `users/${id}`, method: 'DELETE' }),
      invalidatesTags: ['users'],
    }),
  }),
})

export const {
  useUserListQuery,
  useGetUserQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
  useRemoveUserMutation,
} = userApi
